import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiHelperFunction } from '../Helper/Helper';

const initialState = {
  status: false,
  FileURL: '',
};

export const FileUpload = createAsyncThunk('/Upload', async (data) => {
  console.log(data, "data")
  const response = await ApiHelperFunction({
    urlPath: '/file',
    method: 'POST',
    formData: data,
  });

  return response;
});


export const UploadSlice = createSlice({
  name: 'Category',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(FileUpload.pending, (state) => {
        state.status = true;
      })
      .addCase(FileUpload.fulfilled, (state, action) => {
        state.status = false;
        let { response } = action.payload.data;
        state.authToken = response.token;
      })
      .addCase(FileUpload.rejected, (state, action) => {
        state.status = false;
      });
  },
});

export default UploadSlice.reducer;
// export const { } = CategorySlice.actions;
